@if (!!contenidoQr()) {
  <div class="qrcodeImage" class="mt-4 text-center">
    @if (!!titulo()) {
      <h6>{{titulo()}}</h6>
    }
    <qrcode
      [qrdata]="contenidoQr()"
      [allowEmptyString]="true"
      [alt]="'A custom alt attribute'"
      [ariaLabel]="'QR Code image with the following content...'"
      [cssClass]="'center'"
      [colorDark]="'#000000ff'"
      [colorLight]="'#ffffffff'"
      [elementType]="'img'"
      [errorCorrectionLevel]="'L'"
      [margin]="4"
      [scale]="8"
      [title]="tituloQr()"
      [width]="150"
    ></qrcode>
  </div>
}